var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('module',[(_vm.auth('b_coupon_view'))?_c('coupon-list'):_vm._e(),(_vm.auth('b_coupon_task_view'))?_c('coupon-task-list'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }